const BaseUrl = {
    Login: '/login',
    XacThuc: '/#/xac-thuc',
    Dashboard: '/dashboard'
    // bạn có thể thêm các route khác nếu cần
};

export default BaseUrl;
